export default __webpack_public_path__ + "static/media/gupwallsq.c0e2c5e6.jpg";